import {logListingEvent} from 'src/listing_event';
import {ListingDetail} from 'src/listing_detail';


window.addEventListener('DOMContentLoaded', (e) => {

  if( typeof window.listingEventData !== 'undefined' ) {
    logListingEvent(window.listingEventData);
  }


  ListingDetail.init(window.js_listing, window.listingDetailData);


});
